import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';
import { withIntl } from 'ha/i18n';
import { withRouter } from 'react-router';

import { getCitiesNearby, getCountryName } from '../selectors';
import SearchCitiesNearby from '../components/SearchCitiesNearby';

const enhance = compose(
  connect(
    createStructuredSelector({
      citiesNearby: getCitiesNearby,
      localisedCountry: getCountryName,
    }),
  ),
  withIntl,
  withRouter,
);

export default enhance(SearchCitiesNearby);
